import React from 'react';
import cx from 'classnames';

import styles from './RoundedSection.scss';

export type RoundedSectionType = 'primary-mid-light-yellow' | 'primary-yellow' | 'off-white' | 'white';

type RoundedSectionProps = {
  children?: React.ReactNode;
  className?: string;
  dataAttributes?: Record<string, string>;
  theme?: RoundedSectionType;
  withBottomLedge?: boolean;
  withBottomPadding?: boolean;
  withTopLedge?: boolean;
};

export const RoundedSection: React.FC<RoundedSectionProps> = ({
  children,
  className,
  dataAttributes,
  theme,
  withBottomLedge = false,
  withBottomPadding = false,
  withTopLedge = false,
}) => (
  <section className={cx(styles.section, className, {
    [styles.withBottomLedge]: withBottomLedge,
    [styles.withBottomPadding]: withBottomPadding,
    [styles.withTopLedge]: withTopLedge,
  })} data-theme={theme} {...dataAttributes}>{children}</section>
);
